import React from "react";
import "./ResultCard.css";

const ResultCard = ({ dateTime, liveText = "Satta Wala Live Result Today", gameName, result }) => {
  return (
    <div className="result-block">
      {/* Body */}
      <div className="result-block-body">
        <p className="date-time">{dateTime}</p>
        <p className="live-text">{liveText}</p>
        <h3 className="game-name">{gameName}</h3>
        <h1 className="result-number">{result}</h1>
      </div>
    </div>
  );
};

export default ResultCard;
